import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, CampaignImageDto } from './types';

const initialState: initState = {
  images: [],
};

const raffleImagesSlice = createSlice({
  name: 'raffleImages',
  initialState,
  reducers: {
    setRaffleImages(state: initState, action: PayloadAction<CampaignImageDto[]>) {
      state.images = action.payload;
    },
  },
});

export const { setRaffleImages } = raffleImagesSlice.actions;

export default raffleImagesSlice.reducer;
